import React from "react";
import { FormattedMessage } from "react-intl";

export default [
    {
        name: "name",
        label: <FormattedMessage id="driver.name" />,
        type: "string",
    },
    {
        name: "email",
        label: <FormattedMessage id="driver.email" />,
        type: "string",
    },
    {
        name: "supplierId",
        label: <FormattedMessage id="driver.supplier" />,
        type: "relation",
        collection: "suppliers",
        entityName: "supplier",
        fields: ["name"],
    },
    {
        name: "phoneNumber",
        label: <FormattedMessage id="driver.phone-number" />,
        type: "string",
    },
    {
        name: "clientVersion",
        label: <FormattedMessage id="driver.client-version" />,
        type: "string",
    },
    {
        name: "photo",
        label: <FormattedMessage id="driver.picture" />,
        type: "image",
    },
    {
        name: "driverLicense",
        label: <FormattedMessage id="driver.license" />,
        type: "image",
    },
    {
        name: "qrImage",
        label: <FormattedMessage id="driver.qr-code" />,
        type: "base64image",
        isDownloadable: true,
    },
];
